import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "flex justify-center" };
var _hoisted_2 = { class: "mt-5 text-3xl font-medium text-center" };
var _hoisted_3 = { class: "mt-4 text-center text-lg" };
import { CoreStore } from '@student/modules/store';
import { computed } from "vue";
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SchoolSubscription',
    setup: function (__props) {
        var t = useI18n().t;
        var schoolSubscriptionModalVisible = computed(function () {
            return CoreStore.schoolSubscriptionModalVisible;
        });
        var hide = function () {
            CoreStore.schoolSubscriptionModalVisible = false;
        };
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_dialog = _resolveComponent("e-dialog");
            return (_openBlock(), _createBlock(_component_e_dialog, {
                visible: schoolSubscriptionModalVisible.value,
                name: "school-subscription",
                width: "540px",
                onClose: hide
            }, {
                default: _withCtx(function () { return [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_e_icon, {
                            class: "h-24 w-24 text-red-400",
                            icon: "lock-rounded"
                        })
                    ]),
                    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('subscription.accessBlocked')), 1),
                    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('subscription.contactAdmin')), 1)
                ]; }),
                _: 1
            }, 8, ["visible"]));
        };
    }
});
